/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { styles } from './themes/useChartMarquee.css';

type Props = {
  x1: number;
  y1: number;
  width: number;
  height: number;
};
export function Marquee({ x1, y1, width, height }: Props) {
  return (
    <>
      <rect
        x={x1}
        y={y1}
        width={width}
        height={height}
        class={styles.visMarquee}
        data-oj-private-object="marquee"
      />
      <rect
        x={x1 + 1}
        y={y1 + 1}
        width={Math.max(0, width - 2)}
        height={Math.max(0, height - 2)}
        class={styles.visMarqueeInnerArea}
      />
    </>
  );
}
